/** Query parameter the Dugout Chrome extension puts on its side panel iframe. */
export const EXTENSION_VERSION_PARAM = 'extensionVersion';

/**
 * The version of the Chrome extension hosting this page, or null when Dugout
 * is running as the standalone web app.
 *
 * The extension embeds us cross-origin, so `chrome.runtime` is out of reach
 * and the version rides in on the iframe URL instead. Read this during boot —
 * the router rewrites the query string as the user navigates, and after the
 * first navigation the parameter is gone.
 */
export default function chromeExtensionVersion(): string | null {
  const version = new URLSearchParams(window.location.search).get(EXTENSION_VERSION_PARAM)?.trim();

  // Chrome extension versions are 3–4 dot-separated numeric components.
  if (!version || version.length > 32 || !/^\d+(?:\.\d+){2,3}$/.test(version)) {
    return null;
  }

  return version;
}
